export default {
  loggedIn: {
    deposit: 'Depositar',
    withdraw: 'Sacar',
    balance: 'Saldo Total',
    cash: 'Dinheiro',
    bonus: 'Bônus',
    withdrawable: 'Disponível para Saque',
    transaction: 'Transação',
    history: 'Histórico',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Cofre',
    notification: 'Notificação',
    affiliate: 'Afiliado - Ganhe $5.000 Por Mês',
    affiliateTitle: 'Afiliado',
    affiliateBadge: 'Ganhe $5.000 Por Mês',
    settings: 'Configurações',
    currency: 'Moeda',
    language: 'Idioma',
    liveSupport: 'Suporte ao Vivo',
    signOut: 'Sair'
  }
};
